import React from "react";

import Header from "./Header/Header";
import Body from "./Body/Body";

const AuctionNew = (props) => {
  return (
    <>
      <Header />
      <Body />
    </>
  );
};

export default AuctionNew;
